import { get, isEmpty, isObject, some } from 'lodash';

const isEmptyValue = (value) => (
  isObject(value) ? isEmpty(value) : value === '' || value == null
);

const getCaseTypeValue = (values = {}) => (
  get(values, 'case_type.type') || get(values, 'case_type')
);

const anyEmptyRequiredCaseFormFields = (values = {}) => (
  some([
    getCaseTypeValue(values) === 'network_case' && isEmptyValue(values.network),
    isEmptyValue(values.program),
    isEmptyValue(values.program_entry),
    isEmptyValue(get(values, 'service_case.description')),
    isEmptyValue(get(values, 'service_case.primary_worker_id')),
    isEmptyValue(get(values, 'service_case.service_type')),
  ])
);

const shouldInitializeCaseDetailsForm = (formFields) => (
  !formFields ||
  !get(formFields, 'values', formFields)?.service_case ||
  anyEmptyRequiredCaseFormFields(get(formFields, 'values', formFields))
);

export default shouldInitializeCaseDetailsForm;
